// 
export const testDataIRL = {
    "date": {
        "_seconds": 1787044205,
        "_nanoseconds": 184000000
    },
    "test": true,
    "unfinished": [],
    "lang": "cs",
    "region": "cs",
    "status": "SUCCESS",
    "vin": "WAUZZZ8X1BB0XXXXX",
    "results": {
        "pe": {
            "estimate": 135000,
            "currency": "CZK"
        },
        "rz": {
            "provoz": "2010-04-05T22:00:00.000000Z",
            "taxi": []
        },
        "vin": "WAUZZZ8X1BB0XXXXX",
        "sa": [{
            "t": "Zadní, levostranný držák bezpečnostního pásu může být poškozen. V důsledku toho by se zámek mohl v případě nehody zlomit, snížit kapacitu bezpečnostního pásu a zvýšit riziko zranění cestujících.",
            "l": "https://ec.europa.eu/safety-gate-alerts/screen/webReport/alertDetail/10001373",
            "d": "05-06-2020"
        }, {
            "l": "https://ec.europa.eu/safety-gate-alerts/screen/webReport/alertDetail/252150",
            "t": "null Rozdíly v poměru směsi pro iniciační zařízení airbagů nebo předpínačů bezpečnostních pásů by mohly vést k tomu, že airbagy nebo předpínače bezpečnostních pásů se v případě nehody neaktivují.",
            "d": "24-03-2017"
        }],
        "esumm": "Vozidlo bylo poprvé evidováno v únoru 2018 se stavem 125 357 km, kdy prošlo prohlídkou před registrací v ČR. Následně byl zaznamenán stav 142 890 km v únoru 2020, 160 380 km v lednu 2022, 186 780 km v lednu 2024 a 212 780 km v lednu 2026. Všechna měření emisí proběhla bez problémů. Při prohlídkách v letech 2024 a 2026 byly zjištěny lehké závady, které se opakují. K vozidlu evidujeme servisní záznamy od roku 2012 a dvě pojistné události.",
        "ez": {
            "bs": {
                "m": "04-07-2010",
                "d": [{
                    "code": "4R1",
                    "name_orig": "Power windows",
                    "name": "Elektrické ovládání oken"
                }, {
                    "name": "Pravostranný provoz",
                    "name_orig": "Driving on the right",
                    "code": "AV1"
                }, {
                    "code": "A51",
                    "name": "Audi AG"
                }, {
                    "name": "Sériová kvalita výroby",
                    "name_orig": "Standard-production quality",
                    "code": "AQ0"
                }, {
                    "name": "Provozní povolení, změna",
                    "code": "C01",
                    "name_orig": "Operating permit, alteration"
                }, {
                    "code": "E0A",
                    "name": "Bez akčního modelu",
                    "name_orig": "No special edition"
                }, {
                    "name": "Bez speciální úpravy, standardní výbava",
                    "name_orig": "No special purpose vehicle, standard equipment",
                    "code": "F0A"
                }, {
                    "name": "5stupňová manuální převodovka",
                    "code": "G0C",
                    "name_orig": "5-speed manual transmission"
                }, {
                    "name": "Základní varianta výbavy",
                    "code": "FM0",
                    "name_orig": "Basic equipment variant"
                }, {
                    "name": "Baterie 380 A (68 Ah)",
                    "name_orig": "Battery 380 A (68 Ah)",
                    "code": "J2D"
                }, {
                    "code": "VF0",
                    "name": "Standardní pedály",
                    "name_orig": "Standard pedal cluster"
                }, {
                    "name": "Zaváděcí série",
                    "name_orig": "Introductory volume",
                    "code": "S0C"
                }, {
                    "code": "1PA",
                    "name_orig": "Standard wheel bolts",
                    "name": "Standardní šrouby kol"
                }, {
                    "code": "0YA",
                    "name": "Hmotnostní třída 1 - pouze řízení montáže, bez předpovědi poptávky",
                    "name_orig": "Weight range 1 installation control only, no requirement forecast"
                }, {
                    "name_orig": "Heavy-duty rear axle (design 2)",
                    "code": "0N7",
                    "name": "Zesílená zadní náprava (provedení 2)"
                }, {
                    "name_orig": "Tool kit",
                    "code": "1S2",
                    "name": "Nářadí"
                }, {
                    "name_orig": "Information kit in German",
                    "code": "0VC",
                    "name": "Palubní literatura v němčině"
                }, {
                    "name_orig": "Standard climatic zones",
                    "code": "0Y1",
                    "name": "Mírné klimatické pásmo"
                }, {
                    "name_orig": "First aid kit with warning triangle",
                    "code": "1T3",
                    "name": "Lékárnička a výstražný trojúhelník"
                }, {
                    "name": "Zvýšení prvotní náplně paliva",
                    "name_orig": "Increase in initial standard fuel filling",
                    "code": "1Z6"
                }, {
                    "name_orig": "Dust and pollen filter",
                    "name": "Prachový a pylový filtr",
                    "code": "2V1"
                }, {
                    "code": "2C5",
                    "name_orig": "Axial and vertical adjustable steering column",
                    "name": "Výškově a podélně nastavitelný volant"
                }, {
                    "name_orig": "Side and rear windows in heat-insulatingglass",
                    "name": "Tepelně izolační boční a zadní okna",
                    "code": "4KC"
                }, {
                    "name": "Nositeľný kmitočet 433,92 MHz–434,42 MHz",
                    "name_orig": "Carrier frequency 433.92 MHz-434.42 Mhz",
                    "code": "5D1"
                }, {
                    "name_orig": "Standard bumpers",
                    "name": "Standardní nárazníky",
                    "code": "2JB"
                }, {
                    "code": "5J1",
                    "name": "Zadní střešní spojler",
                    "name_orig": "Rear spoiler"
                }, {
                    "name": "Ukazatel stavu náplně ostřikovačů",
                    "name_orig": "Washer fluid level indicator",
                    "code": "8W1"
                }, {
                    "name_orig": "Rear window wiper and washer system with intermittent control",
                    "code": "8M1",
                    "name": "Stěrač a ostřikovač zadního okna s cyklovačem"
                }, {
                    "name": "Země bez tropického klimatu",
                    "name_orig": "Not hot country",
                    "code": "8Z5"
                }, {
                    "name_orig": "Key for locking system",
                    "code": "8QM",
                    "name": "Klíč pro zamykací systém"
                }, {
                    "code": "8GU",
                    "name_orig": "Alternator 140 A",
                    "name": "Generátor 140 A"
                }, {
                    "name_orig": "Suspension range 60 installation control only, no requirement forecast",
                    "name": "Odpružení tř. 60 - pouze řízení montáže, bez předpovědi poptávky",
                    "code": "L60"
                }, {
                    "code": "K8G",
                    "name": "Hatchback"
                }, {
                    "code": "H43",
                    "name_orig": "Tires 215/45 R16 90V xl",
                    "name": "Pneumatiky 215/45 R16 90V xl"
                }, {
                    "code": "0FA",
                    "name": "Standardní výrobní proces",
                    "name_orig": "Standard manufacturing sequence"
                }, {
                    "code": "0F6",
                    "name": "Palivová soustava pro turbodiesel s přímým vstřikováním (TDI)",
                    "name_orig": "Fuel system for turbo diesel engine withdirect injection (TDI)"
                }, {
                    "name_orig": "Emission standard EU5",
                    "code": "7MG",
                    "name": "Emisní norma EU5"
                }, {
                    "name": "Pasivní reproduktory",
                    "name_orig": "Passive speakers",
                    "code": "8RX"
                }, {
                    "name": "Zadní panel držáku SPZ (ECE)",
                    "name_orig": "Rear trim panel (ECE)",
                    "code": "6V1"
                }, {
                    "name_orig": "Electric auxiliary air heater",
                    "code": "7E6",
                    "name": "Elektrické přídavné topení"
                }, {
                    "name": "Přední držák registrační značky (velký)",
                    "code": "6W1",
                    "name_orig": "Front license plate carrier (large)"
                }, {
                    "code": "8N4",
                    "name_orig": "Windshield wiper intermittent control with potentiometer (four speeds)",
                    "name": "Přední stěrače s cyklovačem a nastavením intervalu (4 stupně)"
                }, {
                    "code": "A00",
                    "name_orig": "No self-collection",
                    "name": "Bez osobního odběru"
                }, {
                    "name_orig": "Transit coating (type 1)",
                    "name": "Ochranný transportní lak (typ 1)",
                    "code": "NT0"
                }, {
                    "name_orig": "Standard battery/alternator capacity",
                    "name": "Standardní kapacita akumulátoru a alternátoru",
                    "code": "NY0"
                }, {
                    "name_orig": "Fuel quality < 50 ppm",
                    "code": "0U2",
                    "name": "Kvalita paliva < 50 ppm"
                }, {
                    "code": "4P2",
                    "name_orig": "Rear floor panel module, type 3",
                    "name": "Modul zadní podlahy, typ 3"
                }, {
                    "name": "Posilovač řízení",
                    "code": "1N4",
                    "name_orig": "Power steering"
                }, {
                    "name": "Palivová nádrž se speciální úpravou materiálu",
                    "name_orig": "Fuel tank with special material treatment",
                    "code": "2LB"
                }, {
                    "name": "Třída platformy 4",
                    "name_orig": "Platform group class 4",
                    "code": "7PD"
                }, {
                    "code": "TF3",
                    "name_orig": "4-cylinder diesel engine 1.6 l unit 03L.1",
                    "name": "4válcový vznětový motor 1,6 l, agregát 03L.1"
                }, {
                    "name": "Sada na opravu pneumatik",
                    "name_orig": "Breakdown set",
                    "code": "1G8"
                }, {
                    "name": "Nápisy/štítky v angličtině a němčině",
                    "name_orig": "Labels/plates in English and German",
                    "code": "2KR"
                }, {
                    "name": "Vnější zpětné zrcátko vpravo: konvexní (velké zorné pole)",
                    "code": "5RU",
                    "name_orig": "Right exterior mirror: convex (large viewing field)"
                }, {
                    "code": "8K4",
                    "name_orig": "Separate daytime running lights NAR",
                    "name": "Oddělené denní svícení NAR"
                }, {
                    "name_orig": "Smoking package, ashtray front",
                    "code": "9JD",
                    "name": "Kuřácká výbava, popelník vpředu"
                }, {
                    "name_orig": "Seat belt reminder, electric contact in buckle",
                    "name": "Signalizace nezapnutých bezpečnostních pásů, elektrický kontakt v zámku pásu",
                    "code": "9P6"
                }, {
                    "code": "FA0",
                    "name_orig": "Control of standard production",
                    "name": "Řízení sériové výroby"
                }, {
                    "name": "Sériová kola",
                    "code": "FQ0",
                    "name_orig": "Standard production wheels"
                }, {
                    "code": "L0L",
                    "name_orig": "Left-hand drive vehicle",
                    "name": "Vozidlo s řízením vlevo"
                }, {
                    "name": "Standardní přední sedadla",
                    "name_orig": "Standard front seats",
                    "code": "Q1A"
                }, {
                    "code": "3NZ",
                    "name": "Zadní sedadlo nedělené, opěradlo dělené a sklopné",
                    "name_orig": "Rear seat bench unsplit, backrest split folding"
                }, {
                    "name": "Vyhřívání předních sedadel s oddělenou regulací",
                    "name_orig": "Seat heater for front seats separately controlled",
                    "code": "4A3"
                }, {
                    "code": "4L2",
                    "name": "Vnitřní zpětné zrcátko s automatickým ztmavováním",
                    "name_orig": "Dipping breakaway interior rear view mirror"
                }, {
                    "name": "Ochranná transportní fólie s dodatečnými opatřeními na ochranu při přepravě",
                    "name_orig": "Transit coating film with additional transport protection measures",
                    "code": "5K5"
                }, {
                    "code": "6NJ",
                    "name": "Standardní tvarovaná stropnice",
                    "name_orig": "Standard molded headlining"
                }, {
                    "name": "Elektronický imobilizér",
                    "name_orig": "Electronic vehicle immobilization device",
                    "code": "7AA"
                }, {
                    "code": "7F9",
                    "name_orig": "Plastic/leather gearshift knob/handle",
                    "name": "Plastová/kožená hlavice/rukojeť řadicí páky"
                }, {
                    "name": "Zadní mlhové světlo",
                    "code": "8TB",
                    "name_orig": "Rear fog light"
                }, {
                    "code": "8WB",
                    "name": "Přední mlhové světlomety",
                    "name_orig": "Front fog lights"
                }, {
                    "name_orig": "Service interval prolongation",
                    "code": "QG1",
                    "name": "Prodloužení servisního intervalu"
                }, {
                    "code": "7M3",
                    "name_orig": "Scuff plates in door apertures",
                    "name": "Prahové lišty ve dveřních otvorech"
                }, {
                    "code": "4GF",
                    "name": "Čelní sklo tepelně izolační",
                    "name_orig": "Windshield in heat-insulating glass"
                }, {
                    "name": "Typ pneumatiky: provedení 2",
                    "name_orig": "Type of tire: design 2",
                    "code": "VG6"
                }, {
                    "code": "3Q1",
                    "name_orig": "Rear headrests",
                    "name": "Zadní hlavové opěrky"
                }, {
                    "name": "Airbag řidiče a spolujezdce",
                    "name_orig": "Air bag for driver and front seat passenger",
                    "code": "4UE"
                }, {
                    "name": "Označení typu vzadu, resp. nápisy 'Quattro'",
                    "name_orig": "Type sign at rear and 'Quattro' nameplates respectively",
                    "code": "2Z1"
                }, {
                    "name_orig": "Left exterior mirror: aspherical",
                    "code": "5SL",
                    "name": "Vnější zpětné zrcátko vlevo: asférické"
                }, {
                    "name": "Zadní koncovka výfuku (standardní)",
                    "code": "0P0",
                    "name_orig": "Rear exhaust tailpipe (standard)"
                }, {
                    "name": "Dálkově ovládané centrální zamykání",
                    "name_orig": "Radio remote controlled central locking",
                    "code": "4K4"
                }, {
                    "code": "0TD",
                    "name": "Vkládané koberce vpředu a vzadu",
                    "name_orig": "Front and rear floor mats"
                }, {
                    "code": "4X3",
                    "name": "Boční airbagy vpředu s hlavovými airbagy",
                    "name_orig": "Side air bag front with curtain air bag"
                }, {
                    "name": "Multifunkční ukazatel / palubní počítač",
                    "name_orig": "Multi-function display/on-board computer",
                    "code": "9Q7"
                }, {
                    "name_orig": "Instrument insert with km/h speedometer,clock, tachometer and trip odometer",
                    "code": "U1A",
                    "name": "Sdružený přístroj s tachometrem v km/h, hodinami, otáčkoměrem a denním počítadlem kilometrů"
                }, {
                    "name": "Hliníkový dekorační paket",
                    "name_orig": "Aluminum applications",
                    "code": "GS1"
                }, {
                    "name": "Manuálně výškově nastavitelná přední sedadla",
                    "name_orig": "Manual height adjustment for front seats",
                    "code": "3L3"
                }, {
                    "code": "YCJ",
                    "name": "-"
                }, {
                    "name": "Popisek centrální elektriky pro německy mluvící země",
                    "code": "0W1",
                    "name_orig": "Label for central electric German-speaking countries"
                }, {
                    "code": "1EX",
                    "name": "Typový štítek ES pro osobní vozidla M1",
                    "name_orig": "Special identification plate for EC for M1 passenger vehicle"
                }, {
                    "name_orig": "Special plates/decals/ safety certificates for Germany",
                    "code": "0LW",
                    "name": "Speciální štítky / nálepky / bezpečnostní certifikáty pro Německo"
                }, {
                    "name_orig": "Type approval Germany",
                    "code": "B01",
                    "name": "Homologace pro Německo"
                }, {
                    "name": "Národní prodejní program Německo",
                    "code": "X0A",
                    "name_orig": "National sales program Germany"
                }, {
                    "name": "4válcový turbodiesel 1,6 l / 77 kW (4V) TDI Common Rail, základní motor TF3/TN1/TJ1/TI7",
                    "code": "D38",
                    "name_orig": "4-cyl. turbo dies. eng. 1.6 l/77 kW (4V) TDI common rail base engine is TF3/TN1/TJ1/TI7"
                }, {
                    "name": "Kód řízení 8",
                    "code": "YBS",
                    "name_orig": "Control code 8"
                }, {
                    "name_orig": "Leather trimmed sports steering wheel",
                    "name": "Sportovní kožený volant",
                    "code": "2PV"
                }, {
                    "code": "6XC",
                    "name": "Vnější zpětná zrcátka: elektricky nastavitelná",
                    "name_orig": "Exterior mirrors: electrically adjustable"
                }, {
                    "code": "0AR",
                    "name_orig": "Front stabilizer",
                    "name": "Přední stabilizátor"
                }, {
                    "name_orig": "Disc brakes, rear (Geomet D)",
                    "name": "Kotoučové brzdy vzadu (Geomet D)",
                    "code": "1KT"
                }, {
                    "code": "1ZC",
                    "name_orig": "Disc brakes, front (Geomet D)",
                    "name": "Kotoučové brzdy vpředu (Geomet D)"
                }, {
                    "code": "3J1",
                    "name_orig": "Height-adjustable headrests for front seats",
                    "name": "Výškově nastavitelné hlavové opěrky předních sedadel"
                }, {
                    "code": "4ZA",
                    "name_orig": "Standard moldings",
                    "name": "Standardní ozdobné lišty"
                }, {
                    "code": "8Q1",
                    "name_orig": "Headlight-range adjustment",
                    "name": "Regulace sklonu světlometů"
                }, {
                    "name": "Systém Start-Stop s rekuperací brzdné energie",
                    "code": "7L6",
                    "name_orig": "Start/stop system with regenerative braking"
                }, {
                    "name_orig": "Child seat anchor",
                    "code": "3B3",
                    "name": "Uchycení dětské sedačky (Isofix)"
                }, {
                    "code": "7KR",
                    "name": "Odlišení třídy vozidla 8X0",
                    "name_orig": "Vehicle class differentiation 8X0"
                }, {
                    "name_orig": "Halogen headlight",
                    "name": "Halogenové světlomety",
                    "code": "8BD"
                }, {
                    "code": "8SG",
                    "name_orig": "Standard taillight assemblies (type 2)",
                    "name": "Standardní koncová světla (typ 2)"
                }, {
                    "code": "9AB",
                    "name_orig": "Manually controlled air conditioning",
                    "name": "Manuální klimatizace"
                }, {
                    "code": "A9B",
                    "name": "Dosud neurčená výbava",
                    "name_orig": "Equipment not designated yet"
                }, {
                    "code": "N0L",
                    "name": "Látkové čalounění sedadel",
                    "name_orig": "Fabric seat covering"
                }, {
                    "code": "UG3",
                    "name": "Komfortní asistent řízení",
                    "name_orig": "Comfort driving assist"
                }, {
                    "name": "2dveřové provedení",
                    "name_orig": "2 doors",
                    "code": "0A1"
                }, {
                    "name": "Odjištění opěradel předních sedadel s funkcí 'Easy Entry'",
                    "code": "3H9",
                    "name_orig": "Backrest release for front seats with 'Easy Entry'"
                }, {
                    "code": "RCM",
                    "name_orig": "'concert' radio with BOSE sound system",
                    "name": "Rádio 'concert' se sound systémem BOSE"
                }, {
                    "code": "0EJ",
                    "name_orig": "Installation differentiation for transmission MQ 250 vehicle components",
                    "name": "Montážní odlišení dílů vozidla pro převodovku MQ 250"
                }, {
                    "code": "6H0",
                    "name_orig": "Basic",
                    "name": "Základní výbava"
                }, {
                    "code": "8AL",
                    "name": "Radio Media Center (RMC)",
                    "name_orig": "Radio media center (RMC)"
                }, {
                    "name": "Přední tlumiče",
                    "name_orig": "Front shock absorption",
                    "code": "G23"
                }, {
                    "code": "1AT",
                    "name_orig": "Electronic stabilization program (ESP)",
                    "name": "Elektronický stabilizační program (ESP)"
                }, {
                    "name_orig": "Decorative inserts",
                    "name": "Dekorační obložení",
                    "code": "5MA"
                }, {
                    "name_orig": "Rear shock absorption, base version",
                    "code": "UC0",
                    "name": "Zadní odpružení, standardní provedení"
                }, {
                    "name": "Kola z lehké slitiny 7J x 16",
                    "name_orig": "Alloy wheels 7J x 16",
                    "code": "CT3"
                }, {
                    "code": "PV2",
                    "name_orig": "Electrically adjustable driver s seat",
                    "name": "Elektricky nastavitelné sedadlo řidiče"
                }, {
                    "name_orig": "National sales program for rest of K-V-3",
                    "name": "Národní prodejní program K-V-3",
                    "code": "X7W"
                }, {
                    "name_orig": "Without customized installation",
                    "code": "FC0",
                    "name": "Bez úprav zákaznického centra"
                }, {
                    "name": "Bez tažného zařízení",
                    "name_orig": "Without trailer hitch",
                    "code": "1D0"
                }, {
                    "code": "1SA",
                    "name_orig": "Without additional front underbody guard",
                    "name": "Bez přídavného krytu podvozku vpředu"
                }, {
                    "name": "Bez střešního okna (standardní střecha)",
                    "name_orig": "Without roof insert (standard roof)",
                    "code": "3FA"
                }, {
                    "code": "2WA",
                    "name_orig": "Without additional tires",
                    "name": "Bez přídavných pneumatik"
                }, {
                    "code": "7HA",
                    "name": "Bez koženého čalounění",
                    "name_orig": "Without leather"
                }, {
                    "name_orig": "Without park distance control",
                    "name": "Bez parkovacích senzorů",
                    "code": "7X0"
                }, {
                    "name": "Bez bederní opěrky v opěradlech sedadel",
                    "code": "7P0",
                    "name_orig": "Without lumbar support in seat backrests"
                }, {
                    "code": "7Q0",
                    "name_orig": "Without navigation device",
                    "name": "Bez navigačního systému"
                }, {
                    "code": "UF0",
                    "name_orig": "Without electric interface",
                    "name": "Bez elektrického rozhraní"
                }, {
                    "code": "2G5",
                    "name_orig": "Filler neck module 1 without insert",
                    "name": "Palivové hrdlo 1 bez vložky"
                }, {
                    "name": "Bez tempomatu",
                    "name_orig": "Without cruise control system (CCS)",
                    "code": "8T0"
                }, {
                    "code": "7QA",
                    "name": "Bez CD/DVD pro navigaci",
                    "name_orig": "Without CD/DVD for navigation"
                }, {
                    "code": "9T0",
                    "name": "Bez vyhřívaných trysek ostřikovačů",
                    "name_orig": "Without heated washer nozzles"
                }, {
                    "name": "Bez přípravy pro systém sledování vozidla (VTS)",
                    "code": "7G0",
                    "name_orig": "Without preparation for VTS (vehicle tracking system)"
                }, {
                    "code": "3W0",
                    "name": "Bez dodatečného odhlučnění interiéru",
                    "name_orig": "Without additional noise suppression measures for passenger compartment"
                }, {
                    "name": "Bez indikátoru opotřebení brzdových destiček",
                    "name_orig": "Without brake pad wear indicator",
                    "code": "9U0"
                }, {
                    "name_orig": "Tires w/o specification of tire brand",
                    "code": "V0A",
                    "name": "Pneumatiky bez určení značky"
                }, {
                    "name": "Bez nádobky s aktivním uhlím",
                    "code": "1E0",
                    "name_orig": "Without activated charcoal canister"
                }, {
                    "name": "Bez dekoračních fólií / emblémů",
                    "code": "6F0",
                    "name_orig": "Without decorative films / emblems"
                }, {
                    "code": "6FA",
                    "name_orig": "Components without special surface appearance",
                    "name": "Díly bez zvláštní povrchové úpravy"
                }, {
                    "name": "Bez zadního stabilizátoru",
                    "name_orig": "Without rear stabilizer",
                    "code": "0BA"
                }, {
                    "name": "Bez příjmu TV / digitálního rádiového příjmu (DAB)",
                    "name_orig": "W/o TV reception/digital radio reception",
                    "code": "QV0"
                }, {
                    "code": "9W0",
                    "name": "Bez přípravy / instalace pro telefon",
                    "name_orig": "W/o car phone preparation/installation"
                }, {
                    "code": "QQ0",
                    "name_orig": "Without add. lights (interior lighting)",
                    "name": "Bez přídavného osvětlení (vnitřní osvětlení)"
                }, {
                    "code": "3X0",
                    "name": "Bez možnosti prostrčení dlouhých předmětů (vak na lyže)",
                    "name_orig": "Without load-through provision"
                }, {
                    "code": "QH0",
                    "name": "Bez hlasového ovládání",
                    "name_orig": "Without voice control"
                }, {
                    "name": "Bez systému kontroly tlaku v pneumatikách",
                    "name_orig": "Without tire pressure warning light",
                    "code": "7K0"
                }, {
                    "code": "B0A",
                    "name_orig": "Component parts set without country-specific design requirement",
                    "name": "Sada dílů bez specifických požadavků pro danou zemi"
                }, {
                    "name_orig": "Without tray areas package/box",
                    "name": "Bez odkládacího paketu / schránky",
                    "code": "QE0"
                }, {
                    "code": "8X0",
                    "name": "Bez ostřikovačů světlometů",
                    "name_orig": "Without headlight washer system"
                }, {
                    "code": "7A7",
                    "name_orig": "Without CD changer",
                    "name": "Bez CD měniče"
                }, {
                    "name": "Bez přední středové loketní opěrky",
                    "name_orig": "Without center armrest front",
                    "code": "6E0"
                }, {
                    "name": "Bez označení modelu a technologie (bez označení typu)",
                    "name_orig": "Without nameplate set (without model designation)",
                    "code": "0NA"
                }]
            },
            "sh": [{
                "meter": 186480,
                "date": "2024-01-03",
                "type": "service",
                "unit": "km",
                "provider": "Autoservis Pelhrimov, Nadrazni 122, 393 01 Pelhrimov, Czechia",
                "actions": [{
                    "name": "Výměna motorového oleje a olejového filtru.",
                    "name_orig": "Engine oil and oil filter change."
                }, {
                    "name_orig": "Fuel filter change.",
                    "name": "Výměna palivového filtru."
                }]
            }, {
                "unit": "km",
                "type": "service",
                "date": "2023-08-14",
                "provider": "Autoservis Pelhrimov, Nadrazni 122, 393 01 Pelhrimov, Czechia",
                "meter": 181180,
                "actions": [{
                    "name": "Dvouhmotový setrvačník (nadměrná vůle).",
                    "name_orig": "Dual-mass flywheel (Excessive play)."
                }, {
                    "name_orig": "Clutch kit (Wear).",
                    "name": "Spojková sada (opotřebení)."
                }, {
                    "name_orig": "High-pressure fuel pump (Rail pressure drop).",
                    "name": "Vysokotlaké čerpadlo paliva (pokles tlaku v railu)."
                }]
            }, {
                "unit": "km",
                "type": "service",
                "date": "2021-12-30",
                "meter": 160180,
                "provider": "Autoservis Pelhrimov, Nadrazni 122, 393 01 Pelhrimov, Czechia",
                "actions": [{
                    "name_orig": "Brake discs and pads, front axle (Wear).",
                    "name": "Brzdové kotouče a destičky přední nápravy (opotřebení)."
                }, {
                    "name_orig": "Front wheel bearing (Noise, play).",
                    "name": "Ložisko předního kola (hluk, vůle)."
                }, {
                    "name": "Výměna motorového oleje a olejového filtru.",
                    "name_orig": "Engine oil and oil filter change."
                }, {
                    "name": "Výměna stěračů.",
                    "name_orig": "Wiper blade replacement."
                }]
            }, {
                "provider": "Audi Centrum Praha, Chodovska 3, 141 00 Praha, Czechia",
                "unit": "km",
                "type": "service",
                "date": "2018-11-12",
                "meter": 132352,
                "actions": [{
                    "name": "Turbodmychadlo (nadměrná vůle rotoru, únik oleje do sání).",
                    "name_orig": "Turbocharger (Excessive shaft play, oil loss into intake)."
                }, {
                    "name_orig": "Diesel particulate filter (Ash loaded, regeneration not possible).",
                    "name": "Filtr pevných částic (naplnění popelem, regeneraci nelze provést)."
                }, {
                    "name_orig": "Injectors (Excessive fuel return flow).",
                    "name": "Vstřikovače (nadměrný zpětný odtok paliva)."
                }, {
                    "name": "Geometrie přední nápravy (mimo toleranci).",
                    "name_orig": "Front axle geometry (Out of tolerance)."
                }]
            }, {
                "date": "2016-05-24",
                "unit": "km",
                "type": "service",
                "meter": 184732,
                "actions": [{
                    "name_orig": "Shock absorbers, front axle (Leaking).",
                    "name": "Tlumiče přední nápravy (netěsnost)."
                }, {
                    "name_orig": "Front control arm bushings (Play).",
                    "name": "Silentbloky předních ramen (vůle)."
                }, {
                    "name": "Kondenzátor klimatizace (netěsnost).",
                    "name_orig": "A/C condenser (Leaking)."
                }, {
                    "name_orig": "Engine oil and oil filter change.",
                    "name": "Výměna motorového oleje a olejového filtru."
                }, {
                    "name": "Výměna palivového filtru.",
                    "name_orig": "Fuel filter change."
                },
                {
                    "name": "Výměna vzduchového filtru.",
                    "name_orig": "Air filter change."
                },
                {
                    "name": "Výměna kabinového filtru.",
                    "name_orig": "Cabin filter change."
                }],
                "provider": "Audi Zentrum Dresden, Dohnaer Strasse 99, 01219 Dresden, Germany"
            }, {
                "meter": 125828,
                "provider": "Audi Zentrum Dresden, Dohnaer Strasse 99, 01219 Dresden, Germany",
                "unit": "km",
                "type": "service",
                "date": "2014-05-06",
                "actions": [{
                    "name": "Výměna rozvodového řemene, napínáku a vodního čerpadla.",
                    "name_orig": "Timing belt, tensioner and water pump replacement."
                }, {
                    "name": "Brzdové kotouče a destičky přední nápravy (opotřebení).",
                    "name_orig": "Brake discs and pads, front axle (Wear)."
                }, {
                    "name": "Akumulátor (snížená kapacita).",
                    "name_orig": "Battery (Reduced capacity)."
                }, {
                    "name": "Kontrola upevnění palivového potrubí (svolávací akce).",
                    "name_orig": "Fuel line attachment check (Recall campaign)."
                }, {
                    "name": "Výměna motorového oleje a olejového filtru.",
                    "name_orig": "Engine oil and oil filter change."
                },
                {
                    "name": "Výměna palivového filtru.",
                    "name_orig": "Fuel filter change."
                },
                {
                    "name": "Výměna vzduchového filtru.",
                    "name_orig": "Air filter change."
                },
                {
                    "name": "Výměna kabinového filtru.",
                    "name_orig": "Cabin filter change."
                }]
            }, {
                "actions": [{
                    "name": "Výměna motorového oleje a olejového filtru.",
                    "name_orig": "Engine oil and oil filter change."
                }, {
                    "name": "Výměna palivového, vzduchového a kabinového filtru.",
                    "name_orig": "Fuel, air and cabin filter change."
                }, {
                    "name_orig": "Brake pads, front axle (Wear).",
                    "name": "Brzdové destičky přední nápravy (opotřebení)."
                }],
                "type": "service",
                "unit": "km",
                "provider": "Audi Zentrum Dresden, Dohnaer Strasse 99, 01219 Dresden, Germany",
                "meter": 62655,
                "date": "2012-04-18"
            },
            {
                "actions": [
                    {
                        "name": "Výměna motorového oleje a olejového filtru.",
                        "name_orig": "Engine oil and oil filter change."
                    },
                    {
                        "name": "Kontrola brzdové soustavy a stavu pneumatik.",
                        "name_orig": "Brake system and tyre condition check."
                    }
                ],
                "date": "2011-10-06",
                "meter": 46991,
                "provider": "Audi Zentrum Dresden, Dohnaer Strasse 99, 01219 Dresden, Germany",
                "type": "service",
                "unit": "km"
            },
            {
                "actions": [
                    {
                        "name": "Výměna motorového oleje a olejového filtru.",
                        "name_orig": "Engine oil and oil filter change."
                    },
                    {
                        "name": "Výměna kabinového filtru.",
                        "name_orig": "Cabin filter change."
                    }
                ],
                "date": "2011-03-28",
                "meter": 31328,
                "provider": "Audi Zentrum Dresden, Dohnaer Strasse 99, 01219 Dresden, Germany",
                "type": "service",
                "unit": "km"
            },
            {
                "actions": [
                    {
                        "name": "Výměna motorového oleje a olejového filtru.",
                        "name_orig": "Engine oil and oil filter change."
                    }
                ],
                "date": "2010-09-21",
                "meter": 15664,
                "provider": "Audi Zentrum Dresden, Dohnaer Strasse 99, 01219 Dresden, Germany",
                "type": "service",
                "unit": "km"
            }]
        },
        "insurance": {
            "claims": [{
                "vin": "WAUZZZ8X1BB0XXXXX",
                "assessment": {
                    "damagePositions": "08,05,02,23,14,09",
                    "currency": "EUR",
                    "damageGroups": "012,004,005,009,006",
                    "damageValue": "8027.14",
                    "mandateCode": "",
                    "customerRole": "Garage"
                },
                "vehicle": {
                    "firstRegistration": "",
                    "engineCC": "1598",
                    "carManufacturer": "AUDI",
                    "mileage": "215350",
                    "carModel": "A1 05/10-04/15 (8X) [V] [S] [3D] [IRE] [03]"
                },
                "country": "DEU",
                "creation": "2017-08-05",
                "insurance": {
                    "country": ""
                },
                "damage": {
                    "glass": {
                        "front": false,
                        "roof": false,
                        "sideLeft": false,
                        "rear": false,
                        "sideRight": false
                    },
                    "general": {
                        "frontRight": true,
                        "interior": false,
                        "front": true,
                        "rearLeft": false,
                        "rear": false,
                        "frontLeft": true,
                        "sideLeft": false,
                        "roof": false,
                        "mechanical": true,
                        "rearRight": true,
                        "underbody": false,
                        "sideRight": true
                    }
                },
                "id": "2017-08-05.DEU.1201612124312712",
                "claimInfo": {
                    "accidentDate": "2017-08-05"
                }
            }, {
                "id": "2021-02-08.CZE.7B41C0A9E2F14D8FA0C3B25E11D77A64",
                "damage": {
                    "glass": {
                        "sideRight": false,
                        "rear": false,
                        "sideLeft": false,
                        "front": false,
                        "roof": false
                    },
                    "general": {
                        "rearRight": false,
                        "underbody": false,
                        "frontLeft": false,
                        "rearLeft": false,
                        "mechanical": false,
                        "sideRight": false,
                        "front": false,
                        "sideLeft": false,
                        "rear": true,
                        "roof": false,
                        "frontRight": false,
                        "interior": false
                    }
                },
                "country": "CZE",
                "vehicle": {
                    "firstRegistration": "",
                    "engineCC": "1598",
                    "mileage": "151120",
                    "carModel": "A1 05/10-04/15 (8X) [V] [S] [3D] [IRE] [03]",
                    "carManufacturer": "AUDI"
                },
                "claimInfo": {
                    "accidentDate": "2021-02-08"
                },
                "assessment": {
                    "currency": "CZK",
                    "damageValue": "30412.00",
                    "damageGroups": "004,006",
                    "mandateCode": "",
                    "customerRole": "",
                    "damagePositions": "08,05,14,02"
                },
                "creation": "2021-02-08",
                "vin": "WAUZZZ8X1BB0XXXXX",
                "insurance": {
                    "country": ""
                }
            }],
            "photos": {
                "1201612124312712": ["photos/ZXQHCIM0GD20SGU2/1201612124312712/1.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/2.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/3.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/4.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/5.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/6.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/7.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/8.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/9.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/10.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/11.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/12.jpg"]
            },
            "photosIdentifier": "d50e0e3f-6997-11f1-82d8-005056a754cd"
        },
        "dk": {
            "vyrazeni": [],
            "defect_codes": [{
                "description": "Brzdový kotouč nadměrně zkorodovaný (hloubková koroze) – poškozená funkční plocha zjevně nepřesahuje 1/5 její šířky nebo brzdový kotouč s rýhami zjevně nepřesahující hloubku rýhy 1,5 mm.",
                "type": "A",
                "code": "1.1.14.1.1"
            }, {
                "description": "Tlumič pérování je poškozený nebo netěsný avšak tato závada nemá vliv na provozní vlastnosti vozidla.",
                "code": "5.3.2.2.1",
                "type": "A"
            }, {
                "type": "A",
                "description": "Povrchová koroze rámu nebo pomocného rámu vozidla, která nemá vliv na pevnost konstrukce vozidla.",
                "code": "6.1.1.3.1"
            }, {
                "type": "A",
                "code": "6.2.1.1.1",
                "description": "Povrchová koroze kabiny, karoserie nebo nástavby vozidla."
            }],
            "dovoz": [{
                "s": 50,
                "d": "2018-01-12"
            }],
            "vybaveni": [],
            "stanice_stk": [{
                "Cislo": "123456"
            }, {
                "Cislo": "1234"
            }],
            "pcv": "15198513",
            "tacho": [{
                "v": "WAUZZZ8X1BB0XXXXX",
                "s": "123456",
                "t": 1,
                "o": 125357,
                "d": "2018-02-07"
            }, {
                "v": "WAUZZZ8X1BB0XXXXX",
                "s": "1234",
                "t": 7,
                "r": 1,
                "o": 125357,
                "d": "2018-02-08"
            }, {
                "s": "1234",
                "v": "WAUZZZ8X1BB0XXXXX",
                "r": 1,
                "t": 1,
                "d": "2020-02-11",
                "o": 142890
            }, {
                "s": "123456",
                "v": "WAUZZZ8X1BB0XXXXX",
                "d": "2020-02-11",
                "o": 142890,
                "t": 1,
                "r": 1
            }, {
                "r": 1,
                "t": 1,
                "d": "2022-01-05",
                "o": 160380,
                "s": "1234",
                "v": "WAUZZZ8X1BB0XXXXX"
            }, {
                "s": "123456",
                "v": "WAUZZZ8X1BB0XXXXX",
                "r": 1,
                "t": 1,
                "d": "2022-01-05",
                "o": 160380
            }, {
                "t": 1,
                "r": 1,
                "d": "2024-01-11",
                "o": 186780,
                "s": "1234",
                "v": "WAUZZZ8X1BB0XXXXX",
                "f": ["5.3.2.2.1", "6.2.1.1.1"]
            }, {
                "o": 186780,
                "d": "2024-01-11",
                "r": 1,
                "t": 1,
                "v": "WAUZZZ8X1BB0XXXXX",
                "s": "123456"
            }, {
                "f": ["5.3.2.2.1", "6.2.1.1.1", "6.1.1.3.1", "1.1.14.1.1"],
                "v": "WAUZZZ8X1BB0XXXXX",
                "s": "1234",
                "o": 212780,
                "d": "2026-01-15",
                "r": 1,
                "t": 1
            }, {
                "o": 212780,
                "d": "2026-01-15",
                "r": 1,
                "t": 1,
                "v": "WAUZZZ8X1BB0XXXXX",
                "s": "123456"
            }],
            "vlastnik": [{
                "d": "2018-02-15",
                "v": "2"
            }, {
                "v": "1",
                "d": "2018-02-15"
            }, {
                "v": "2",
                "d": "2021-04-24"
            }, {
                "v": "1",
                "d": "2021-04-24"
            }]
        },
        "base": {
            "NejvyssiRychlost": 190,
            "OrvZadrzeno": false,
            "PocetProvozovatelu": 2,
            "VozidloKaroserieBarva": "ŠEDÁ",
            "CisloTp": "UI140663",
            "HmotnostiPripPovBrzdenePV": "1200/ 1200",
            "EmiseCO2": " /  / 103",
            "VozidloKaroserieMist": "4 / 4 / 0",
            "Rozmery": "3954/ 1740/ 1407",
            "EmiseEHKOSNEHSES": " / 692/2008A",
            "NapravyPneuRafky": "205/55 R15 88V / 6.5J X 15 ET34 ;\n205/55 R15 88V / 6.5J X 15 ET34 ;\n/ ;\n/ ;\n",
            "HmotnostiPripPovNebrzdenePV": "600/ 600",
            "SpotrebaMetodika": "692/2008A",
            "HmotnostiPripPovN": "920/ 920;\n765/ 765;\n/ ;\n/ ;\n",
            "EmiseKSA": 0.5,
            "RzZadrzena": false,
            "PocetVlastniku": 2,
            "VozidloVyrobce": "AUDI",
            "Kategorie": "M1",
            "HmotnostiProvozni": 1215,
            "Verze": "FM5",
            "MotorTyp": "CAY",
            "NapravyPocetDruh": "2/ - 1 PŘEDNÍ",
            "Rozchod": "1456/ 1450/ / ",
            "HmotnostiPripPovJS": "2820/ 2820",
            "ObchodniOznaceni": "A1",
            "VozidloElektricke": "NE",
            "VyrobceKaroserie": "AUDI",
            "MotorMaxVykon": "77 / 4400",
            "VozidloUcel": "Běžný provoz",
            "VozidloHybridni": "NE",
            "Typ": " / 8X",
            "HomologaceEs": "e1*2007/46*0414*",
            "CisloOrv": "UAS814870",
            "RozmeryLoznaSirka": 0,
            "HmotnostiZatizeniSZ": 50,
            "VozidloAutonomniStupen": "Neuvedeno",
            "DatumPrvniRegistrace": "2010-08-02T00:00:00",
            "MotorZdvihObjem": 1598,
            "CisloTypovehoSchvaleni": "7752-002-00",
            "RozmeryRozvor": "2457",
            "MotorVyrobce": "AUDI",
            "HlukJizda": 71,
            "ZarazeniVozidla": "RSV",
            "RzDruh": "STD. SILNIČNÍ",
            "VIN": "WAUZZZ8X1BB0XXXXX",
            "DalsiZaznamy": "Variabilní provedení vozidla:|*20-21:|6J x 15 ET29; 185/60 R15 88H M+S|6J x 16 ET30; 195/50 R16 88H M+S|7.5J x 17 ET36; 215/40 R17 87W|7J x 16 ET34; 215/45 R16 90V|Vozidlo plní požadavky zákona čís. 56/2001 Sb.|ROZCHOD: 1 456/1 450|*12: 3 964|*14: 1 427|ROK VÝR. NEURČEN, PRVNÍ REG. VOZ. DLE TP Z D, 28,12,2010",
            "PredRegistraciProhlidkaDne": "2018-02-08T00:00:00",
            "DatumPrvniRegistraceVCr": "2018-02-15T00:00:00",
            "RzVarianta": 101,
            "HlukStojiciOtacky": "71/ 2375",
            "StatusNazev": "PROVOZOVANÉ",
            "HmotnostiPripPov": "1590/ 1590",
            "Palivo": "NM",
            "TovarniZnacka": "AUDI",
            "SpotrebaNa100Km": "4.7 / 3.5 / 3.9",
            "HmotnostiZatizeniSZTyp": "Z",
            "KaroserieDruh": "3 DVÉŘOVÁ",
            "Varianta": "ACAYCF1",
            "VozidloDruh": "OSOBNÍ AUTOMOBIL",
            "VozidloDruh2": "AC KOMBI",
            "RozmeryLoznaDelka": 0,
            "PravidelnaTechnickaProhlidkaDo": "2028-01-15T00:00:00"
        },
        "lang": "cs",
        "stolen": {
            "found": [],
            "status": false,
            "checked": ["internal", "si", "it", "ro", "cs", "sk", "hu"]
        }
    }
};
export const testData = testDataIRL;
export const testData2 = {
    "unfinished": [],
    "retries": 0,
    "vin": "WBAFF41050L052802",
    "last_retry": {
        "type": "firestore/timestamp/1.0",
        "seconds": 1762441326,
        "nanoseconds": 250000000
    },
    "date": new Date(2025, 5, 12),
    "status": "SUCCESS",
    "results": {
        "base": {
            "TovarniZnacka": "BMW",
            "ObchodniOznaceni": "X5 3.0 D",
            "Typ": "BMW X5 3.0 D X70 / X70",
            "EvidencniProhlidkaDne": "2013-06-26T00:00:00",
            "VozidloElektricke": "NE",
            "HmotnostiPripPov": "2740/ 2740",
            "OrvOdevzdano": null,
            "AlternativniProvedeni": null,
            "HlukStojiciOtacky": "79/ 3000",
            "DalsiZaznamy": "CO2: 301/191/231 g/km|Variabilní provedení vozidla:|#F.1/F.2: 2 860/2 860 - při provozu s přípojným vozidlem|#N: 1 710/1 710 - pro zadní nápravu při provozu s přípojným vozidlem|#20: 9J X 19 ET48; 255/50 R19 107V|#21: 9J X 19 ET48; 255/50 R19 107V|#20: 9J X 19 ET48; 255/50 R19 107V|#21: 10J X 19 ET53; 285/45 R19 111V|#20: 10J X 20 ET40; 275/40 R20 106W|#21: 11J X 20 ET37; 315/35 R20 110W|#20: 10J X 21 ET40; 285/35 R21 105W|#21: 11.5J X 21 ET42; 325/30 R21 108W|Sněhové řetězy lze montovat na zadní nápravu jen v souladu s pokyny|výrobce. Vozidlo plní požadavky zákona č. 56/2001 Sb.",
            "KaroserieDruh": "KOMBI",
            "RzZadrzena": false,
            "StatusNazev": "PROVOZOVANÉ",
            "VozidloHybridni": "NE",
            "EmiseEHKOSNEHSES": " / 2003/76B",
            "VozidloHybridniTrida": null,
            "RzKeSkartaci": null,
            "VozidloKaroserieMist": "5 / 5 / 0",
            "VozidloKaroserieBarvaDoplnkova": null,
            "EmisniUroven": "EURO 4",
            "MotorVyrobce": "BMW, AG, MNICHOV, SRN",
            "SpotrebaEl": null,
            "VozidloKaroserieBarva": "STŘÍBRNÁ-METAL",
            "HmotnostiPripPovJS": "5560/ 5560",
            "ZarazeniVozidla": "RSV",
            "DatumPrvniRegistrace": "1995-06-07T00:00:00",
            "HistorickeVozidloProhlidkaDne": null,
            "Kategorie": "M1G",
            "CisloTp": null,
            "DatumPrvniRegistraceVCr": "1996-08-06T00:00:00",
            "PredRegistraciProhlidkaDne": null,
            "MotorZdvihObjem": 2993,
            "PocetVlastniku": 5,
            "NejvyssiRychlost": 210,
            "EmiseSnizeniWltp": null,
            "DojezdZR": null,
            "Spotreba": null,
            "HomologaceEs": "e1*2001/116*0420*",
            "HmotnostiPripPovNebrzdenePV": "750/ 750",
            "Rozmery": "4854/ 1933/ 1766",
            "KaroserieVyrobniCislo": null,
            "VozidloAutonomniStupen": "Neuvedeno",
            "NapravyPocetDruh": "2/ - 2",
            "MotorMaxVykon": "173 / 4000",
            "HmotnostiProvozni": 2180,
            "EmiseSnizeniNedc": null,
            "VozidloUcel": "Běžný provoz",
            "InovativniTechnologie": null,
            "VyrobceKaroserie": "BMW, AG, MNICHOV, SRN",
            "VozidloSpojZarizNazev": "TŘÍDA A50-X",
            "RzOdevzdano": null,
            "EmiseKSA": 0.5,
            "VIN": "WBAFF41050L052802",
            "VozidloVyrobce": "BMW, AG, MNICHOV, SRN",
            "Verze": "02",
            "HmotnostiPripPovN": "1295/ 1295;\n1545/ 1545;\n/ ;\n/ ;\n",
            "FaktorVerifikaceVf": null,
            "HmotnostUzitecneZatizeniPrumer": null,
            "HmotnostiTestWltp": null,
            "PravidelnaTechnickaProhlidkaDo": "2026-10-30T00:00:00",
            "SpotrebaMetodika": "ES1999/100",
            "PocetProvozovatelu": 6,
            "OrvZadrzeno": false,
            "PredSchvalenimProhlidkaDne": null,
            "SpotrebaNa100Km": "11.3 / 7.2 / 8.7",
            "EmiseCO2Specificke": null,
            "HlukJizda": 73,
            "OrvKeSkartaci": null,
            "PomerVykonHmotnost": null,
            "VozidloDruh2": "AC KOMBI",
            "FaktorOdchylkyDe": null,
            "Palivo": "NM",
            "Varianta": "FF41",
            "MotorTyp": "306 D3",
            "NapravyPneuRafky": "255/55 R18 109H/ 8.5J X 18 ET46;\n255/55 R18 109H/ 8.5J X 18 ET46;\n/ ;\n/ ;\n",
            "CisloOrv": "UBL032370",
            "VozidloDruh": "OSOBNÍ AUTOMOBIL",
            "CisloTypovehoSchvaleni": "6484-001-00",
            "Rozchod": "/ / / ",
            "RzDruh": "STD. SILNIČNÍ",
            "RzJkVydana": null,
            "EmiseCO2": "301 / 191 / 231",
            "HmotnostiPripPovBrzdenePV": "2700/ 2700",
            "RozmeryRozvor": "2 933",
            "StupenDokonceni": null
        },
        "insurance": {
            "claims": [{
                "id": "2022-01-19.DEU.92D851E63B624B5CB60C7B65D53DEFFF",
                "vin": "WAUZZZ8X1BB004047",
                "country": "DEU",
                "creation": "2022-01-19",
                "vehicle": {
                    "carManufacturer": "AUDI",
                    "carModel": "A1 05/10-04/15 (8X) [V] [S] [3D] [IRE] [03]",
                    "engineCC": "1598",
                    "firstRegistration": "",
                    "mileage": ""
                },
                "assessment": {
                    "damageGroups": "004",
                    "damagePositions": "02,08,11,05",
                    "damageValue": "2925.33",
                    "currency": "EUR",
                    "customerRole": "Assessor",
                    "mandateCode": ""
                },
                "claimInfo": {
                    "accidentDate": ""
                },
                "insurance": {
                    "country": ""
                },
                "damage": {
                    "general": {
                        "front": true,
                        "frontLeft": true,
                        "frontRight": true,
                        "rear": false,
                        "rearLeft": false,
                        "rearRight": false,
                        "sideLeft": true,
                        "sideRight": false,
                        "roof": false,
                        "interior": false,
                        "mechanical": false,
                        "underbody": false
                    },
                    "glass": {
                        "front": false,
                        "rear": false,
                        "roof": false,
                        "sideLeft": false,
                        "sideRight": false
                    }
                }
            }, {
                "id": "2016-11-22.DEU.E3F221862BC723C14023E48CE9759F56",
                "vin": "WAUZZZ8X1BB004047",
                "country": "DEU",
                "creation": "2016-11-22",
                "vehicle": {
                    "carManufacturer": "AUDI",
                    "carModel": "A1 05/10-04/15 (8X) [V] [S] [3D] [IRE] [03]",
                    "engineCC": "",
                    "firstRegistration": "",
                    "mileage": ""
                },
                "assessment": {
                    "damageGroups": "012,004,005,009,006",
                    "damagePositions": "08,05,02,23,14,09",
                    "damageValue": "8027.14",
                    "currency": "EUR",
                    "customerRole": "Garage",
                    "mandateCode": ""
                },
                "claimInfo": {
                    "accidentDate": ""
                },
                "insurance": {
                    "country": ""
                },
                "damage": {
                    "general": {
                        "front": true,
                        "frontLeft": true,
                        "frontRight": true,
                        "rear": false,
                        "rearLeft": false,
                        "rearRight": true,
                        "sideLeft": false,
                        "sideRight": true,
                        "roof": false,
                        "interior": false,
                        "mechanical": true,
                        "underbody": false
                    },
                    "glass": {
                        "front": false,
                        "rear": false,
                        "roof": false,
                        "sideLeft": false,
                        "sideRight": false
                    }
                }
            }, {
                "id": "2016-11-11.DEU.E3F221862BC723C14023E48CE9759F56",
                "vin": "WAUZZZ8X1BB004047",
                "country": "DEU",
                "creation": "2016-11-11",
                "vehicle": {
                    "carManufacturer": "AUDI",
                    "carModel": "A1 05/10-04/15 (8X) [V] [S] [3D] [IRE] [03]",
                    "engineCC": "",
                    "firstRegistration": "",
                    "mileage": ""
                },
                "assessment": {
                    "damageGroups": "012,004,005,009,006",
                    "damagePositions": "08,05,02,23,14,09",
                    "damageValue": "8027.14",
                    "currency": "EUR",
                    "customerRole": "Garage",
                    "mandateCode": ""
                },
                "claimInfo": {
                    "accidentDate": ""
                },
                "insurance": {
                    "country": ""
                },
                "damage": {
                    "general": {
                        "front": false,
                        "frontLeft": false,
                        "frontRight": false,
                        "rear": false,
                        "rearLeft": false,
                        "rearRight": false,
                        "sideLeft": false,
                        "sideRight": false,
                        "roof": false,
                        "interior": false,
                        "mechanical": false,
                        "underbody": false
                    },
                    "glass": {
                        "front": false,
                        "rear": false,
                        "roof": false,
                        "sideLeft": false,
                        "sideRight": false
                    }
                }
            }, {
                "id": "2018-08-10.AON.1201808106934702",
                "vin": "WAUZZZ8X1BB004047",
                "country": "AON",
                "creation": "2018-08-10",
                "vehicle": {
                    "carManufacturer": "AUDI",
                    "carModel": "A1 (8X) OD 05/2010 [V] [S] [3D] [IRE] [03]",
                    "engineCC": "0",
                    "firstRegistration": "",
                    "mileage": ""
                },
                "assessment": {
                    "damageGroups": null,
                    "damagePositions": null,
                    "damageValue": "0.00",
                    "currency": "",
                    "customerRole": "",
                    "mandateCode": ""
                },
                "claimInfo": {
                    "accidentDate": ""
                },
                "insurance": {
                    "country": "SK"
                },
                "damage": {
                    "general": {
                        "front": false,
                        "frontLeft": false,
                        "frontRight": false,
                        "rear": false,
                        "rearLeft": false,
                        "rearRight": false,
                        "sideLeft": false,
                        "sideRight": false,
                        "roof": false,
                        "interior": false,
                        "mechanical": false,
                        "underbody": false
                    },
                    "glass": {
                        "front": false,
                        "rear": false,
                        "roof": false,
                        "sideLeft": false,
                        "sideRight": false
                    }
                }
            }, {
                "id": "2018-08-20.AON.1231808106934702",
                "vin": "WAUZZZ8X1BB004047",
                "country": "AON",
                "creation": "2018-08-20",
                "vehicle": {
                    "carManufacturer": "AUDI",
                    "carModel": "A1 (8X) OD 05/2010 [V] [S] [3D] [IRE] [03]",
                    "engineCC": "0",
                    "firstRegistration": "",
                    "mileage": ""
                },
                "assessment": {
                    "damageGroups": null,
                    "damagePositions": null,
                    "damageValue": "0.00",
                    "currency": "",
                    "customerRole": "",
                    "mandateCode": ""
                },
                "claimInfo": {
                    "accidentDate": ""
                },
                "insurance": {
                    "country": "SK"
                },
                "damage": {
                    "general": {
                        "front": false,
                        "frontLeft": false,
                        "frontRight": false,
                        "rear": false,
                        "rearLeft": false,
                        "rearRight": false,
                        "sideLeft": false,
                        "sideRight": false,
                        "roof": false,
                        "interior": false,
                        "mechanical": false,
                        "underbody": false
                    },
                    "glass": {
                        "front": false,
                        "rear": false,
                        "roof": false,
                        "sideLeft": false,
                        "sideRight": false
                    }
                }
            }, {
                "id": "2016-12-12.AON.1201612124312712",
                "vin": "WAUZZZ8X1BB004047",
                "country": "AON",
                "creation": "2016-12-12",
                "vehicle": {
                    "carManufacturer": "AUDI",
                    "carModel": "A1",
                    "engineCC": "1598",
                    "firstRegistration": "2010-12-28",
                    "mileage": "40786"
                },
                "assessment": {
                    "damageGroups": null,
                    "damagePositions": null,
                    "damageValue": "8127.32",
                    "currency": "",
                    "customerRole": "",
                    "mandateCode": ""
                },
                "claimInfo": {
                    "accidentDate": ""
                },
                "insurance": {
                    "country": "D"
                },
                "damage": {
                    "general": {
                        "front": false,
                        "frontLeft": false,
                        "frontRight": false,
                        "rear": false,
                        "rearLeft": false,
                        "rearRight": false,
                        "sideLeft": false,
                        "sideRight": false,
                        "roof": false,
                        "interior": false,
                        "mechanical": false,
                        "underbody": false
                    },
                    "glass": {
                        "front": false,
                        "rear": false,
                        "roof": false,
                        "sideLeft": false,
                        "sideRight": false
                    }
                }
            }],
            "photos": {
                "1201612124312712": ["photos/ZXQHCIM0GD20SGU2/1201612124312712/1.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/2.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/3.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/4.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/5.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/6.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/7.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/8.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/9.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/10.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/11.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/12.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/13.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/14.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/15.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/16.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/17.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/18.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/19.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/20.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/21.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/22.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/23.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/24.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/25.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/26.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/27.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/28.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/29.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/30.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/31.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/32.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/33.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/34.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/35.jpg", "photos/ZXQHCIM0GD20SGU2/1201612124312712/36.jpg"]
            },
            "photosIdentifier": "d50e0e3f-6997-11f1-82d8-005056a754cd"
        },
        "stolen": {
            "checked": ["internal", "si", "it", "ro", "cs", "sk", "hu"],
            "found": ["it"],
            "status": true
        },
        "working": false,
        "country": "cs",
        "rz": {
            "provoz": "2007-08-05T22:00:00.000000Z",
            "taxi": ["cz"]
        },
        "dk": {
            "pcv": "2115076",
            "dovoz": [{
                "s": 124
            }, {
                "d": "2006-03-23",
                "s": 123
            }, {
                "d": "2000-04-23",
                "s": 122
            }],
            "vlastnik": [
                //{ "v": "1", "d": "1997-11-20" },
                { "v": "2", "d": "1997-11-20" },
                { "v": "2", "d": "2000-06-09" },
                { "v": "1", "d": "2000-06-09" },
                { "v": "2", "d": "2015-01-16" },
                { "v": "1", "d": "2015-01-16", i: '08393494', n: 'Metastream s.r.o.' },
                { "v": "2", "d": "2023-06-09" },
                { "v": "1", "d": "2023-06-09" },
                { "v": "2", "d": "2025-09-08" },
                { "v": "2", "d": "2026-06-09" },
                { "v": "1", "d": "2026-06-09" },
                // { "v": "1", "d": "2025-09-08" }
            ],
            "vybaveni": [
                {
                    "s": 19
                },
                {
                    "s": 22
                }
            ],
            "vyrazeni": [
                { "r": 1, "rm": "3441", "df": "2010-09-13", "dt": "2013-05-29" },
                { "r": 0, "rm": "3441", "df": "2010-07-13", "dt": "2010-08-29" },
                { "r": 2, "rm": "3441", "df": "2010-08-13", "dt": "2025-08-14" },
            ],
            "tacho": [{
                "d": "2008-12-17",
                "s": "3302",
                "v": "W0L0SBF68W4052404",
                "o": 30118,
                "r": 1,
                "t": 1,
                "f": ["7072"]
            }, {
                "d": "2010-12-16",
                "s": "3302",
                "v": "W0L0SBF68W4052404",
                "o": 33212,
                "r": 1,
                "t": 1
            }, {
                "d": "2012-12-13",
                "s": "3302",
                "v": "W0L0SBF68W4052404",
                "o": 35166,
                "r": 1,
                "t": 1
            }, {
                "d": "2014-12-04",
                "s": "3302",
                "v": "W0L0SBF68W4052404",
                "o": 33907,
                "r": 1,
                "t": 1,
                "f": ["1.1.11.3.1", "6.1.2.2.1", "6.2.1.1.1"]
            }, {
                "d": "2016-12-06",
                "s": "3327",
                "v": "W0L0SBF68W4052404",
                "o": 39935,
                "r": 1,
                "t": 1
            }, {
                "d": "2018-12-03",
                "s": "3306",
                "v": "W0L0SBF68W4052404",
                "o": 44655,
                "r": 1,
                "t": 1,
                "f": ["5.3.3.2.1", "6.1.2.1.1"]
            }, {
                "d": "2018-12-03",
                "s": "530107",
                "v": "W0L0SBF68W4052404",
                "o": 44639,
                "r": 1,
                "t": 1
            }, {
                "d": "2020-11-25",
                "s": "3306",
                "v": "W0L0SBF68W4052404",
                "o": 47904,
                "r": 1,
                "t": 1,
                "f": ["1.1.14.1.1", "6.1.2.1.1"]
            }, {
                "d": "2020-11-25",
                "s": "530107",
                "v": "W0L0SBF68W4052404",
                "o": 47881,
                "r": 1,
                "t": 1
            }, {
                "d": "2022-11-24",
                "s": "3306",
                "v": "W0L0SBF68W4052404",
                "o": 50315,
                "r": 1,
                "t": 1,
                "f": ["6.1.2.1.1"]
            }, {
                "d": "2022-11-24",
                "s": "530107",
                "v": "W0L0SBF68W4052404",
                "o": 50307,
                "r": 1,
                "t": 1
            }, {
                "d": "2023-01-13",
                "s": "3303",
                "v": "W0L0SBF68W4052404",
                "o": 50578,
                "r": 1,
                "t": 3
            }, {
                "d": "2024-11-01",
                "s": "3303",
                "v": "W0L0SBF68W4052404",
                "o": 58307,
                "r": 1,
                "t": 1
            }, {
                "d": "2024-11-01",
                "s": "430705",
                "v": "W0L0SBF68W4052404",
                "o": 58307,
                "r": 1,
                "t": 1
            }],
            "stanice_stk": [{
                "Cislo": 3302,
                "Kraj": "Jihočeský kraj",
                "Okres": "Český Krumlov",
                "ORP": "Český Krumlov",
                "Obec": "Dolní Třebonín",
                "Ulice": "Dolní Třebonín 195",
                "PSC": 38201,
                "ICO": 25153790,
                "Nazev": "KOMAT - STK s.r.o."
            }, {
                "Cislo": 3303,
                "Kraj": "Jihočeský kraj",
                "Okres": "Strakonice",
                "ORP": "Strakonice",
                "Obec": "Strakonice",
                "Ulice": "Písecká 513",
                "PSC": 38601,
                "ICO": 25151843,
                "Nazev": "Stanice technické kontroly Strakonice s.r.o."
            }, {
                "Cislo": 3306,
                "Kraj": "Jihočeský kraj",
                "Okres": "České Budějovice",
                "ORP": "České Budějovice",
                "Obec": "České Budějovice",
                "Ulice": "Rudolfovská 17",
                "PSC": 37001,
                "ICO": 582158,
                "Nazev": "Vyšší odborná škola, Střední průmyslová škola auto"
            }, {
                "Cislo": 3327,
                "Kraj": "Jihočeský kraj",
                "Okres": "Český Krumlov",
                "ORP": "Český Krumlov",
                "Obec": "Kájov",
                "Ulice": "Kájov 196",
                "PSC": 38201,
                "ICO": 63991551,
                "Nazev": "BĚLOHRADSKÝ spol. s r.o."
            }, {
                "Cislo": 430705,
                "Kraj": "Jihočeský kraj",
                "Okres": "Strakonice",
                "ORP": "Strakonice",
                "Obec": "Strakonice",
                "Ulice": "Písecká 513",
                "PSC": 38601,
                "ICO": 1942355,
                "Nazev": "Autoservis Šrachta s.r.o."
            }, {
                "Cislo": 530107,
                "Kraj": "Jihočeský kraj",
                "Okres": "České Budějovice",
                "ORP": "České Budějovice",
                "Obec": "České Budějovice",
                "Ulice": "Jubilejní 38/48",
                "PSC": 37010,
                "ICO": 17381568,
                "Nazev": "AutoservisHP s.r.o."
            }],
            "defect_codes": [{
                "code": "1.1.11.3.1",
                "description": "Mírná povrchová koroze / oxidace brzdového potrubí.",
                "type": "A"
            }, {
                "code": "1.1.14.1.1",
                "description": "Brzdový kotouč nadměrně zkorodovaný (hloubková koroze) - poškozená funkční plocha zjevně nepřesahuje 1/5 její šířky nebo brzdový kotouč s rýhami zjevně nepřesahující hloubku rýhy 1,5 mm.",
                "type": "A"
            }, {
                "code": "6.1.2.1.1",
                "description": "Drobné netěsnosti ve spojích výfukového systému.",
                "type": "A"
            }, {
                "code": "6.1.2.2.1",
                "description": "Některá část výfukového systému je nedostatečně upevněna nebo upevnění výfukového systému neodpovídá požadavkům a tato závada nemá vliv na funkci systému.",
                "type": "A"
            }, {
                "code": "6.2.1.1.1",
                "description": "Povrchová koroze kabiny, karosérie nebo nástavby vozidla.",
                "type": "A"
            }],
        },
        "sa": [
            {
                "l": "https://ec.europa.eu/safety-gate-alerts/screen/webReport/alertDetail/10004450",
                "d": "01-10-2021",
                "t": "Kvůli konkrétní chybě aktualizace softwaru, která může způsobit náhlé resetování, může dojít k poškození modulu datové komunikace (DCM). V důsledku toho již nebude možné zahájit tísňové volání prostřednictvím systému eCall.  Výrobek nesplňuje požadavky stanovené v nařízení o schvalování motorových vozidel a jejich přípojných vozidel a systémů, konstrukčních částí a samostatných technických celků určených pro tato vozidla a dozoru nad trhem s nimi."
            },
            {
                "l": "https://ec.europa.eu/safety-gate-alerts/screen/webReport/alertDetail/10003464",
                "d": "02-04-2021",
                "t": "Vzhledem k nedostatečné trvanlivosti může chladič recirkulace výfukových plynů (EGR) vytvořit únik vnitřního chladicího média, který by mohl vytvořit doutnající ložiska uvnitř chladiče EGR a sacího potrubí. To může mít za následek lokalizované tepelné poškození v sacím systému, které by mohlo vést ke snížení výkonu motoru a ke zvýšenému riziku požáru."
            },
            {
                "l": "https://ec.europa.eu/safety-gate-alerts/screen/webReport/alertDetail/10007932",
                "d": "03-03-1993",
                "t": "Pomocný bateriový terminál může být vadný. To může deaktivovat podporu posilovače řízení. Bateriový terminál se navíc může přehřát při nízkých rychlostech, což zvyšuje riziko požáru. Výrobek není v souladu s nařízením o schvalování motorových vozidel a jejich přípojných vozidel a dozoru nad trhem s nimi, jakož i s systémy, konstrukčními částmi a samostatnými technickými celky určenými pro tato vozidla."
            },
            {
                "t": "null Sestava sloupce řízení obsahuje elektrické připojení k modulu airbagu řidiče umístěného ve spirálovém kabelu, které se může po otáčení volantu poškodit. Pokud se tak stane, může se vzduchová taška řidiče deaktivovat a v případě havárie se tedy nenasadit.",
                "d": "02-05-2014",
                "l": "https://ec.europa.eu/safety-gate-alerts/screen/webReport/alertDetail/111967"
            },
            {
                "l": "https://ec.europa.eu/safety-gate-alerts/screen/webReport/alertDetail/10007932",
                "d": "03-03-2023",
                "t": "Pomocný bateriový terminál může být vadný. To může deaktivovat podporu posilovače řízení. Bateriový terminál se navíc může přehřát při nízkých rychlostech, což zvyšuje riziko požáru. Výrobek není v souladu s nařízením o schvalování motorových vozidel a jejich přípojných vozidel a dozoru nad trhem s nimi, jakož i s systémy, konstrukčními částmi a samostatnými technickými celky určenými pro tato vozidla."
            },
        ],
        "ez": {
            "bs": {
                "m": "14-11-1994",
                "d": [
                    { "code": "S710A", "name": "M kožený volant", "name_orig": "M leather steering wheel" },
                    { "code": "S715A", "name": "M Aerodynamics package" },
                    { "code": "S5DCA", "name": "Sklopné zadní opěrky hlavy", "name_orig": "Rear-seat headrests folding" },
                    { "code": "S663A", "name": "Rádio BMW Professional", "name_orig": "Radio BMW Professional" },
                    { "code": "S507A", "name": "Parkovací senzory vzadu", "name_orig": "Park Distance Control (PDC) rear" },
                    { "code": "S534A", "name": "Automatická klimatizace", "name_orig": "Automatic air conditioning" },
                    { "code": "S520A", "name": "Mlhová světla", "name_orig": "Fog lights" },
                    { "code": "S8SPA", "name": "Řídicí jednotka CO2", "name_orig": "Control unit CO2" },
                    { "code": "S1CAA", "name": "Výběr vozidel relevantních pro COP", "name_orig": "Selection of COP-relevant vehicles" },
                    { "code": "S548A", "name": "Kilometrový rychloměr", "name_orig": "Kilometre speedo" },
                    { "code": "P337A", "name": "M sportovní paket", "name_orig": "M Sports package" },
                    { "code": "S481A", "name": "Sportovní sedadlo", "name_orig": "Sports seat" },
                    { "code": "S775A", "name": "Antracitové čalounění stropu", "name_orig": "Headlining anthracite" },
                    { "code": "S423A", "name": "Velurové koberečky", "name_orig": "Floor mats velours" },
                    { "code": "S676A", "name": "HiFi reproduktorový systém", "name_orig": "HiFi speaker system" },
                    { "code": "S863A", "name": "Seznam prodejců pro Evropu", "name_orig": "Dealer List Europe" },
                    { "code": "S879A", "name": "Palubní literatura v němčině", "name_orig": "On-board literature German" },
                    { "code": "S321A", "name": "Označení modelu", "name_orig": "Lettering" },
                    { "code": "S896A", "name": "Denní svícení", "name_orig": "Daytime driving lights" },
                    { "code": "S411A", "name": "Elektricky ovládaná okna vpředu/vzadu", "name_orig": "Window liftselectric&&front/rear" },
                    { "code": "S704A", "name": "M sportovní podvozek", "name_orig": "M Sports suspension" },
                    { "code": "S442A", "name": "Držák nápojů", "name_orig": "Drink holder" },
                    { "code": "S4MGA", "name": "Interiérové lišty hliník Glacier-Silver", "name_orig": "Int. mouldings aluminium glacier-silver" },
                    { "code": "S2MGA", "name": "BMW litá kola, M dvojité paprsky 207", "name_orig": "BMW alloy wheel, M double spoke 207" },
                    { "code": "S339A", "name": "Shadow-Line", "name_orig": "Shadow-Line" }, { "code": "S468A", "name": "Vak na lyže", "name_orig": "Ski bag" },
                    { "code": "S869A", "name": "Jazyková verze Švýcarsko", "name_orig": "Language version Switzerland" }]
            },
            "ki": [{
                "probability": 3,
                "confidence": 0,
                "title": "Brake drums, brake discs",
                "description": "More than 25% rust on one side of the brake disc on the front axle",
                "explanation": "If more than 25% of the brake disc surface is covered by rust, this can significantly impair braking performance and compromise vehicle safety. Rust on the brake disc reduces the friction between the disc and the brake pads, resulting in ineffective braking and increased stopping distance. In addition, rust can cause uneven wear on both the brake pads and the disc, which may lead to vibrations and scraping noises during braking"
            }, {
                "probability": 3,
                "title": "Zpětná zrcátka a jejich upevnění",
                "description": "Zpětné zrcátko nebo jeho upevnění chybí nebo je nesprávně namontováno",
                "explanation": "Vizuální kontrola",
                "confidence": 0,
                "title_orig": "Mirrors and mirror assemblies",
                "description_orig": "Mirror or assembly missing or incorrectly mounted",
                "explanation_orig": "Visual control"
            }, {
                "probability": 3,
                "title": "Mlhová světla – seřízení",
                "description": "Nesprávné seřízení",
                "explanation": "Kontrola pomocí zařízení pro seřizování světlometů (regloskopu). Při kontrole seřízení je nutné použít výrobcem stanovený sklon (pokud není k dispozici, pak 1,5 %). Závada je považována za vážnou, pokud je sklon mlhových světel vyšší než mezní hodnota. Za méně závažnou se považuje, pokud je nastavení příliš nízké.",
                "confidence": 0,
                "title_orig": "Fog lights – aim",
                "description_orig": "Improper adjustment",
                "explanation_orig": "Control using light setting device. When checking the setting, the tilt percentage must be used by the manufacturer (if this is not available 1.5 %). Ancestor is considered serious if the dimensions of the fog lights are higher than the limit value. Deemed as less serious if the setting is too low"
            }],
            "sh": [{
                "date": "2014-03-05",
                "meter": 78580,
                "unit": "km",
                "provider": "Motorr Žilina, Rosinská 8446/5, 010 08 Zilina, Slovakia",
                "type": "service",
                "actions": []
            }, {
                "date": "2014-04-07",
                "meter": 78580,
                "unit": "km",
                "provider": "Motorr Žilina, Rosinská 8446/5, 010 08 Zilina, Slovakia",
                "type": "service",
                "actions": [{
                    "name": "Výměna motorového oleje a filtru.",
                    "name_orig": "Engine: oil and filter change."
                }]
            }, {
                "date": "2013-11-06",
                "meter": 73861,
                "unit": "km",
                "provider": "Hoffmann et al Žižák. s r. o., Zápy 255, 250 61 Zápy, Czechia",
                "type": "service",
                "actions": [{
                    "name": "Výměna motorového oleje a filtru.",
                    "name_orig": "Engine: oil and filter change."
                }, {
                    "name": "Výměna vzduchového filtru.",
                    "name_orig": "Air filter element replaced."
                }, {
                    "name": "Výměna brzdové kapaliny.",
                    "name_orig": "Brake fluid replaced."
                }, {
                    "name": "Výměna zapalovacích svíček.",
                    "name_orig": "Spark plugs replaced."
                }]
            }],
        },
        "pe": { "estimate": 240000, "currency": "CZK" },
        "esumm": "Vozidlo bylo poprvé zaznamenáno 3. prosince 2018 s nájezdem 44 639 km. Během následujících let se nájezd postupně zvyšoval, dosahujíc 47 881 km v listopadu 2020 a 50 307 km v listopadu 2022. K 1. listopadu 2024 činil stav odometru 58 307 km. Všechna měření emisí proběhla bez problémů."
    },
};

export const testDataTwo = {
    "unfinished": [],
    "retries": 0,
    "vin": "WBAFF41050L052802",
    "last_retry": {
        "type": "firestore/timestamp/1.0",
        "seconds": 1762441326,
        "nanoseconds": 250000000
    },
    "date": {
        "type": "firestore/timestamp/1.0",
        "seconds": 1762441326,
        "nanoseconds": 250000000
    },
    "status": "SUCCESS",
    "base": {
        "EvidencniProhlidkaDne": "2013-06-26T00:00:00",
        "VozidloElektricke": "NE",
        "HmotnostiPripPov": "2740/ 2740",
        "OrvOdevzdano": null,
        "AlternativniProvedeni": null,
        "HlukStojiciOtacky": "79/ 3000",
        "DalsiZaznamy": "CO2: 301/191/231 g/km|Variabilní provedení vozidla:|#F.1/F.2: 2 860/2 860 - při provozu s přípojným vozidlem|#N: 1 710/1 710 - pro zadní nápravu při provozu s přípojným vozidlem|#20: 9J X 19 ET48; 255/50 R19 107V|#21: 9J X 19 ET48; 255/50 R19 107V|#20: 9J X 19 ET48; 255/50 R19 107V|#21: 10J X 19 ET53; 285/45 R19 111V|#20: 10J X 20 ET40; 275/40 R20 106W|#21: 11J X 20 ET37; 315/35 R20 110W|#20: 10J X 21 ET40; 285/35 R21 105W|#21: 11.5J X 21 ET42; 325/30 R21 108W|Sněhové řetězy lze montovat na zadní nápravu jen v souladu s pokyny|výrobce. Vozidlo plní požadavky zákona č. 56/2001 Sb.",
        "KaroserieDruh": "KOMBI",
        "RzZadrzena": false,
        "StatusNazev": "PROVOZOVANÉ",
        "VozidloHybridni": "NE",
        "EmiseEHKOSNEHSES": " / 2003/76B",
        "VozidloHybridniTrida": null,
        "RzKeSkartaci": null,
        "VozidloKaroserieMist": "5 / 5 / 0",
        "VozidloKaroserieBarvaDoplnkova": null,
        "EmisniUroven": "EURO 4",
        "MotorVyrobce": "BMW, AG, MNICHOV, SRN",
        "SpotrebaEl": null,
        "VozidloKaroserieBarva": "STŘÍBRNÁ-METAL",
        "Typ": "BMW X5 3.0 D X70 / X70",
        "HmotnostiPripPovJS": "5560/ 5560",
        "ZarazeniVozidla": "RSV",
        "DatumPrvniRegistrace": "2007-08-06T00:00:00",
        "HistorickeVozidloProhlidkaDne": null,
        "Kategorie": "M1G",
        "CisloTp": null,
        "DatumPrvniRegistraceVCr": "2007-08-06T00:00:00",
        "PredRegistraciProhlidkaDne": null,
        "MotorZdvihObjem": 2993,
        "PocetVlastniku": 4,
        "TovarniZnacka": "BMW",
        "NejvyssiRychlost": 210,
        "EmiseSnizeniWltp": null,
        "DojezdZR": null,
        "Spotreba": null,
        "HomologaceEs": "e1*2001/116*0420*",
        "HmotnostiPripPovNebrzdenePV": "750/ 750",
        "Rozmery": "4854/ 1933/ 1766",
        "KaroserieVyrobniCislo": null,
        "VozidloAutonomniStupen": "Neuvedeno",
        "NapravyPocetDruh": "2/ - 2",
        "MotorMaxVykon": "173 / 4000",
        "HmotnostiProvozni": 2180,
        "EmiseSnizeniNedc": null,
        "VozidloUcel": null,
        "InovativniTechnologie": null,
        "VyrobceKaroserie": "BMW, AG, MNICHOV, SRN",
        "VozidloSpojZarizNazev": "TŘÍDA A50-X",
        "RzOdevzdano": null,
        "EmiseKSA": 0.5,
        "VIN": "WBAFF41050L052802",
        "VozidloVyrobce": "BMW, AG, MNICHOV, SRN",
        "Verze": "02",
        "HmotnostiPripPovN": "1295/ 1295;\n1545/ 1545;\n/ ;\n/ ;\n",
        "FaktorVerifikaceVf": null,
        "HmotnostUzitecneZatizeniPrumer": null,
        "HmotnostiTestWltp": null,
        "PravidelnaTechnickaProhlidkaDo": "2026-10-30T00:00:00",
        "ObchodniOznaceni": "X5 3.0 D",
        "SpotrebaMetodika": "ES1999/100",
        "PocetProvozovatelu": 6,
        "OrvZadrzeno": false,
        "PredSchvalenimProhlidkaDne": null,
        "SpotrebaNa100Km": "11.3 / 7.2 / 8.7",
        "EmiseCO2Specificke": null,
        "HlukJizda": 73,
        "OrvKeSkartaci": null,
        "PomerVykonHmotnost": null,
        "VozidloDruh2": "AC KOMBI",
        "FaktorOdchylkyDe": null,
        "Palivo": "NM",
        "Varianta": "FF41",
        "MotorTyp": "306 D3",
        "NapravyPneuRafky": "255/55 R18 109H/ 8.5J X 18 ET46;\n255/55 R18 109H/ 8.5J X 18 ET46;\n/ ;\n/ ;\n",
        "CisloOrv": "UBL032370",
        "VozidloDruh": "OSOBNÍ AUTOMOBIL",
        "CisloTypovehoSchvaleni": "6484-001-00",
        "Rozchod": "/ / / ",
        "RzDruh": "STD. SILNIČNÍ",
        "RzJkVydana": null,
        "EmiseCO2": "301 / 191 / 231",
        "HmotnostiPripPovBrzdenePV": "2700/ 2700",
        "RozmeryRozvor": "2 933",
        "StupenDokonceni": null
    },
    "stolen": {
        "countries": [],
        "status": false
    },
    "tacho": {
        "results": [
            {
                "inspectionType": "Evidencní kontrola",
                "km": "95 228",
                "protocol": "CZ-3120-10-06-1121",
                "type": "STK",
                "detail": {
                    "datum_prohlidky": "18.06.2010",
                    "seznam_zavad": [],
                    "tovarni_znacka": "BMW",
                    "prohlidka": "STK",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "typ_motoru": "306 D3",
                    "cislo_tp_dokladu": "",
                    "stav_km": "95 228",
                    "poznamka": "",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "kategorie_vozidla": "M1G",
                    "obch_oznaceni_typ": "X5",
                    "druh_prohlidky": "Evidencní kontrola",
                    "title": "Detail prohlídky CZ-3120-10-06-1121",
                    "datum_prvni_registrace": "06.08.2007"
                },
                "note": "",
                "date": "18.06.2010"
            },
            {
                "detail": {
                    "datum_prvni_registrace": "06.08.2007",
                    "stav_km": "120 847",
                    "title": "Detail prohlídky CZ-3120-11-07-1433",
                    "poznamka": "",
                    "datum_prohlidky": "28.07.2011",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "typ_motoru": "306 D3",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "seznam_zavad": [],
                    "druh_prohlidky": "Pravidelná",
                    "prohlidka": "STK",
                    "cislo_tp_dokladu": "",
                    "tovarni_znacka": "BMW",
                    "kategorie_vozidla": "M1G",
                    "druh_technicke_zpusobilosti": "způsobilé"
                },
                "note": "",
                "date": "28.07.2011",
                "type": "STK",
                "km": "120 847",
                "protocol": "CZ-3120-11-07-1433",
                "inspectionType": "Pravidelná"
            },
            {
                "note": "",
                "date": "26.06.2013",
                "protocol": "CZ-3213-13-06-1399",
                "km": "160 960",
                "inspectionType": "Evidencní kontrola",
                "detail": {
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "poznamka": "",
                    "datum_prvni_registrace": "06.08.2007",
                    "typ_motoru": "306 D3",
                    "tovarni_znacka": "BMW",
                    "prohlidka": "STK",
                    "title": "Detail prohlídky CZ-3213-13-06-1399",
                    "datum_prohlidky": "26.06.2013",
                    "kategorie_vozidla": "M1G",
                    "cislo_tp_dokladu": "",
                    "druh_prohlidky": "Evidencní kontrola",
                    "stav_km": "160 960",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "seznam_zavad": []
                },
                "type": "STK"
            },
            {
                "type": "STK",
                "detail": {
                    "title": "Detail prohlídky CZ-3213-13-06-1397",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "prohlidka": "STK",
                    "seznam_zavad": [],
                    "druh_prohlidky": "Pravidelná",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "datum_prohlidky": "26.06.2013",
                    "kategorie_vozidla": "M1G",
                    "stav_km": "160 960",
                    "tovarni_znacka": "BMW",
                    "datum_prvni_registrace": "06.08.2007",
                    "cislo_tp_dokladu": "",
                    "typ_motoru": "306 D3",
                    "poznamka": "",
                    "obch_oznaceni_typ": "X5 (X70)"
                },
                "note": "",
                "protocol": "CZ-3213-13-06-1397",
                "km": "160 960",
                "inspectionType": "Pravidelná",
                "date": "26.06.2013"
            },
            {
                "inspectionType": "Pravidelná",
                "date": "22.05.2015",
                "km": "200 954",
                "protocol": "CZ-3232-15-05-1795",
                "detail": {
                    "seznam_zavad": [
                        {
                            "id": "1.1.6.2.1",
                            "text": "Opotřebení v převodu ovladače parkovací brzdy nebo západkového mechanismu, které však nemá vliv na spolehlivost nebo funkci ovládání parkovací brzdy."
                        },
                        {
                            "text": "Netěsnost nápravy.",
                            "id": "5.1.1.5.1"
                        }
                    ],
                    "obch_oznaceni_typ": "X5 (X70)",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "datum_prvni_registrace": "06.08.2007",
                    "typ_motoru": "306 D3",
                    "cislo_tp_dokladu": "",
                    "stav_km": "200 954",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "kategorie_vozidla": "M1G",
                    "datum_prohlidky": "22.05.2015",
                    "druh_prohlidky": "Pravidelná",
                    "poznamka": "",
                    "prohlidka": "STK",
                    "tovarni_znacka": "BMW",
                    "title": "Detail prohlídky CZ-3232-15-05-1795"
                },
                "type": "STK",
                "note": ""
            },
            {
                "protocol": "CZ-3232-17-05-0759",
                "detail": {
                    "typ_motoru": "306 D3",
                    "datum_prvni_registrace": "06.08.2007",
                    "druh_prohlidky": "Pravidelná",
                    "cislo_tp_dokladu": "UC139349",
                    "stav_km": "246 561",
                    "seznam_zavad": [
                        {
                            "id": "5.1.1.5.1",
                            "text": "Netěsnost nápravy."
                        },
                        {
                            "text": "Drobné netěsnosti ve spojích výfukového systému.",
                            "id": "6.1.2.1.1"
                        }
                    ],
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "poznamka": "",
                    "kategorie_vozidla": "M1G",
                    "tovarni_znacka": "BMW",
                    "title": "Detail prohlídky CZ-3232-17-05-0759",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "datum_prohlidky": "10.05.2017",
                    "prohlidka": "STK"
                },
                "km": "246 561",
                "date": "10.05.2017",
                "type": "STK",
                "inspectionType": "Pravidelná",
                "note": ""
            },
            {
                "km": "257 807",
                "inspectionType": "Na žádost zákazníka",
                "detail": {
                    "stav_km": "257 807",
                    "datum_prohlidky": "04.10.2017",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "datum_prvni_registrace": "06.08.2007",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "tovarni_znacka": "BMW",
                    "title": "Detail prohlídky CZ-3232-17-10-0388",
                    "cislo_tp_dokladu": "UC139349",
                    "prohlidka": "STK",
                    "kategorie_vozidla": "M1G",
                    "typ_motoru": "306 D3",
                    "seznam_zavad": [],
                    "poznamka": "",
                    "druh_prohlidky": "Na žádost zákazníka"
                },
                "type": "STK",
                "note": "",
                "date": "04.10.2017",
                "protocol": "CZ-3232-17-10-0388"
            },
            {
                "type": "SME",
                "inspectionType": "Pravidelná",
                "km": "297 800",
                "date": "29.04.2019",
                "protocol": "CZ-410945-19-04-1010",
                "detail": {
                    "prohlidka": "SME",
                    "datum_prvni_registrace": "06.08.2007",
                    "tovarni_znacka": "BMW",
                    "title": "Detail prohlídky CZ-410945-19-04-1010",
                    "druh_technicke_zpusobilosti": "vyhovuje",
                    "kategorie_vozidla": "M1G",
                    "stav_km": "297 800",
                    "poznamka": "",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "druh_prohlidky": "Pravidelná",
                    "cislo_tp_dokladu": "UC139349",
                    "datum_prohlidky": "29.04.2019",
                    "typ_motoru": "306 D3",
                    "seznam_zavad": [],
                    "obch_oznaceni_typ": "X5 (X70)"
                },
                "note": ""
            },
            {
                "type": "STK",
                "detail": {
                    "poznamka": "",
                    "typ_motoru": "306 D3",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "datum_prvni_registrace": "06.08.2007",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "kategorie_vozidla": "M1G",
                    "cislo_tp_dokladu": "UC139349",
                    "tovarni_znacka": "BMW",
                    "stav_km": "297 880",
                    "prohlidka": "STK",
                    "datum_prohlidky": "30.04.2019",
                    "title": "Detail prohlídky CZ-3232-19-04-2121",
                    "seznam_zavad": [],
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "druh_prohlidky": "Pravidelná"
                },
                "inspectionType": "Pravidelná",
                "note": "",
                "km": "297 880",
                "protocol": "CZ-3232-19-04-2121",
                "date": "30.04.2019"
            },
            {
                "date": "08.04.2021",
                "km": "35 564",
                "inspectionType": "Pravidelná",
                "detail": {
                    "druh_prohlidky": "Pravidelná",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "seznam_zavad": [],
                    "prohlidka": "STK",
                    "title": "Detail prohlídky CZ-3117-21-04-0155",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "poznamka": "",
                    "typ_motoru": "306 D3",
                    "cislo_tp_dokladu": "UC139349",
                    "stav_km": "35 564",
                    "datum_prohlidky": "08.04.2021",
                    "datum_prvni_registrace": "06.08.2007",
                    "tovarni_znacka": "BMW",
                    "kategorie_vozidla": "M1G"
                },
                "note": "",
                "type": "STK",
                "protocol": "CZ-3117-21-04-0155"
            },
            {
                "protocol": "CZ-410911-21-04-0046",
                "type": "SME",
                "detail": {
                    "cislo_tp_dokladu": "UC139349",
                    "druh_technicke_zpusobilosti": "vyhovuje",
                    "title": "Detail prohlídky CZ-410911-21-04-0046",
                    "prohlidka": "SME",
                    "datum_prvni_registrace": "06.08.2007",
                    "datum_prohlidky": "08.04.2021",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "poznamka": "",
                    "tovarni_znacka": "BMW",
                    "stav_km": "335 562",
                    "typ_motoru": "306 D3",
                    "seznam_zavad": [],
                    "kategorie_vozidla": "M1G",
                    "druh_prohlidky": "Pravidelná"
                },
                "note": "",
                "inspectionType": "Pravidelná",
                "date": "08.04.2021",
                "km": "335 562"
            },
            {
                "inspectionType": "Pravidelná",
                "protocol": "CZ-3117-23-04-0070",
                "date": "04.04.2023",
                "type": "STK",
                "detail": {
                    "datum_prohlidky": "04.04.2023",
                    "poznamka": "",
                    "stav_km": "378 048",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "tovarni_znacka": "BMW",
                    "kategorie_vozidla": "M1G",
                    "seznam_zavad": [
                        {
                            "text": "Povrchová koroze rámu nebo pomocného rámu vozidla, která nemá vliv na pevnost konstrukce vozidla.",
                            "id": "6.1.1.3.1"
                        },
                        {
                            "id": "6.2.1.1.1",
                            "text": "Povrchová koroze kabiny, karosérie nebo nástavby vozidla."
                        }
                    ],
                    "druh_prohlidky": "Pravidelná",
                    "title": "Detail prohlídky CZ-3117-23-04-0070",
                    "cislo_tp_dokladu": "UC139349",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "prohlidka": "STK",
                    "datum_prvni_registrace": "06.08.2007",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "typ_motoru": "306 D3"
                },
                "note": "",
                "km": "378 048"
            },
            {
                "note": "",
                "km": "378 039",
                "detail": {
                    "seznam_zavad": [],
                    "druh_prohlidky": "Pravidelná",
                    "datum_prvni_registrace": "06.08.2007",
                    "obch_oznaceni_typ": "X5 (X70)",
                    "title": "Detail prohlídky CZ-411047-23-04-0040",
                    "tovarni_znacka": "BMW",
                    "poznamka": "",
                    "cislo_tp_dokladu": "UC139349",
                    "stav_km": "378 039",
                    "typ_motoru": "306 D3",
                    "druh_technicke_zpusobilosti": "vyhovuje",
                    "kategorie_vozidla": "M1G",
                    "prohlidka": "SME",
                    "datum_prohlidky": "04.04.2023",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL"
                },
                "type": "SME",
                "protocol": "CZ-411047-23-04-0040",
                "date": "04.04.2023",
                "inspectionType": "Pravidelná"
            },
            {
                "date": "30.10.2024",
                "type": "STK",
                "detail": {
                    "cislo_tp_dokladu": "UBF599497",
                    "druh_prohlidky": "Pravidelná",
                    "druh_technicke_zpusobilosti": "způsobilé",
                    "prohlidka": "STK",
                    "datum_prohlidky": "30.10.2024",
                    "stav_km": "410 313",
                    "title": "Detail prohlídky CZ-3113-24-10-0577",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "kategorie_vozidla": "M1G",
                    "datum_prvni_registrace": "06.08.2007",
                    "obch_oznaceni_typ": "X5 3.0 D (X70)",
                    "typ_motoru": "306 D3",
                    "tovarni_znacka": "BMW",
                    "poznamka": "",
                    "seznam_zavad": [
                        {
                            "id": "4.1.1.2.1",
                            "text": "Vnější krycí sklo, těleso nebo optický systém potkávacího světlometu nebo dálkového světlometu poškozený, ale stav poškození zjevně neovlivňuje jeho fotometrické vlastnosti (např. intenzita vyzařovaného světla, kresba) nebo možnost jeho seřízení."
                        }
                    ]
                },
                "inspectionType": "Pravidelná",
                "note": "",
                "protocol": "CZ-3113-24-10-0577",
                "km": "410 313"
            },
            {
                "inspectionType": "Pravidelná",
                "protocol": "CZ-411047-24-10-0561",
                "date": "30.10.2024",
                "note": "",
                "km": "410 300",
                "type": "SME",
                "detail": {
                    "datum_prohlidky": "30.10.2024",
                    "title": "Detail prohlídky CZ-411047-24-10-0561",
                    "druh_technicke_zpusobilosti": "vyhovuje",
                    "poznamka": "",
                    "typ_motoru": "306 D3",
                    "tovarni_znacka": "BMW",
                    "prohlidka": "SME",
                    "datum_prvni_registrace": "06.08.2007",
                    "cislo_tp_dokladu": "UBF599497",
                    "kategorie_vozidla": "M1G",
                    "seznam_zavad": [],
                    "druh_prohlidky": "Pravidelná",
                    "druh_vozidla": "OSOBNÍ AUTOMOBIL",
                    "obch_oznaceni_typ": "X5 3.0D",
                    "stav_km": "410 300"
                }
            }
        ],
        "found": true
    },
    "working": false,
    "country": "cs",
    "rz": {
        "provoz": "2007-08-05T22:00:00.000000Z",
        "taxi": true
    },
    "bq":
    {
        "d": [],
        "r": [],
        "v": "WBAFF41050L052802",
        "p": 9086423,
        "o": [
            {
                "i": 28912527,
                "d": "21.06.2010",
                "v": 1
            },
            {
                "d": "21.06.2010",
                "i": 28912527,
                "v": 2
            },
            {
                "i": 28912527,
                "d": "16.06.2010",
                "v": 2
            },
            {
                "i": 25205552,
                "d": "06.08.2007",
                "v": 2
            },
            {
                "i": 29414415,
                "d": "27.06.2013",
                "v": 2
            },
            {
                "i": 29414415,
                "v": 1,
                "d": "27.06.2013"
            },
            {
                "i": 29414415,
                "v": 2,
                "d": "27.06.2013"
            },
            {
                "v": 1,
                "d": "27.06.2013",
                "i": 29414415
            }
        ]
    }

};